<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-broadcast-tower" class="q-mb-sm" /> {{ webcast.title }}
        </div>

        <q-tabs v-model="tab" color="secondary" class="shadow-1">
            <q-tab slot="title" name="stream" :label="$t('stream')" v-if="showTab && show_stream" />
            <q-tab slot="title" name="chat_moderation" :label="$t('chat_moderation')" v-show="showTab && show_chat_moderation" />

            <q-tab-pane name="stream" class="q-px-lg q-pb-xl" keep-alive>
                <stream :id_webcast="webcast.id" />
            </q-tab-pane>

            <q-tab-pane name="chat_moderation" class="q-px-lg q-pb-xl">
                <chat-moderation :id_webcast="webcast.id" @hideModal="hideModal" />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import ChatModeration from 'components/admin/presential/events/ChatModeration'
import Stream from 'components/admin/webcasts/Stream'

export default {
    name: 'AdminPresentialWebcastModal',

    props: ['webcast'],

    data() {
        return {
            tab: 'chat_moderation',
            show_stream: false,
            show_chat_moderation: false
        }
    },

    components: {
        'chat-moderation': ChatModeration,
        'stream': Stream,
    },

    methods: {
        hideModal() {
            this.$emit('hideModal', '')
        },
    },

    computed: {
        showTab() {
            // if (this.id_webcast != 0) return true
            // else return false
            return true
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    mounted () {
        if (this.webcast.webcast_type === 2) this.show_stream = true
        if (this.webcast.use_chat === true) this.show_chat_moderation = true
    },
}
</script>

<style>

</style>
